import { db } from '../../firebaseConfig';
import { createActionSync } from '../sharedConfig/createActionAsync';
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore';

export const setAnswerAction = createActionSync({
  property: 'setAnswer',
  prefix: 'SET_ANSWER',
  promiseMethod: async () => {
    return { data: 'works' };
  },
  options: {
    typeOfQuery: 'all',
  },
});

export const addDataChartsDiagnosticOneActionsAsync = createActionSync({
  property: 'addDataChartsDiagnosticOne',
  prefix: 'ADD_DATA_CHARTS_DIAGNOSTIC_ONE',
  promiseMethod: async ({ params, state }) => {
    const existingData =
      state.addDataChartsDiagnosticOne.data !== null &&
      Array.isArray(state.addDataChartsDiagnosticOne.data.data)
        ? state.addDataChartsDiagnosticOne.data.data
        : [];
    const dataAnswer = params.dataAnswer;

    const finalData = [...existingData];
    finalData.push(dataAnswer);

    return { data: [...finalData] };
  },
  options: {
    typeOfQuery: 'all',
  },
});

export const queryDiagnosticAAction = createActionSync({
  property: 'queryDiagnosticA',
  prefix: 'QUERY_DIAGNOSTIC_A',
  promiseMethod: async () => {
    const q = query(collection(db, 'Respuestas'), orderBy('timestamp', 'desc'));
    const querySnapshot = await getDocs(q);
    const respuestas = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    return { data: respuestas };
  },
  options: {
    typeOfQuery: 'single',
  },
});

export const queryFormDiagnosticBActionASync = createActionSync({
  property: 'queryFormDiagnosticBState',
  prefix: 'QUERY_FORM_DIAGNOSTIC_B',
  promiseMethod: async ({ params: { idFrom } }) => {
    const q = query(
      collection(db, 'TokenizationDiagnostics'),
      where('idToken', '==', idFrom),
      orderBy('createdAt', 'desc'),
      limit(1),
    );
    const querySnapshot = await getDocs(q);
    const respuestas = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    return { data: respuestas[0] ?? null };
  },
  options: {
    typeOfQuery: 'all',
  },
});
